export default {
    navigationBarTitleText: '设计营销施工全家桶',
    navigationBarBackgroundColor: '#DF773C',
};
